



































































import {Component, Mixins} from 'vue-mixin-decorator';
import {BaseComponent} from '@/mixins/BaseComponent';
import {getModule} from 'vuex-module-decorators';

import {Notify} from '@/utils/Notify';
import {EventBus} from '@/utils/EventBus';

import {Profile} from '@/model/network/profile/Profile';

import NetworkProfilesStore from '@/store/network/NetworkProfiles.store';
import NetworkConnectionsStore from '@/store/network/NetworkConnections.store';

import NetworkVpnSettingsDisplay from '@/components/Networking/Vpn/NetworkVpnSettingsDisplay.vue';
import NetworkVpnSettingsDisplayOpenVpn from '@/components/Networking/Vpn/NetworkVpnSettingsDisplayOpenVpn.vue';
import NetworkVpn from '@/components/Networking/Vpn/NetworkVpn.vue';
import NetworkVpnAddWizard from '@/components/Networking/Vpn/NetworkVpnAddWizard.vue';

@Component({
  components: {NetworkVpnAddWizard, NetworkVpn, NetworkVpnSettingsDisplayOpenVpn, NetworkVpnSettingsDisplay},
})
export default class NetworkVpnPage extends Mixins<BaseComponent>(BaseComponent) {
  private profilesStore: NetworkProfilesStore = getModule(NetworkProfilesStore, this.$store);

  private connectionsStore: NetworkConnectionsStore = getModule(NetworkConnectionsStore, this.$store);

  private selectedProfile: string | null = null;

  private refreshing: boolean = false;

  private addWizard: boolean = false;

  private async mounted() {
    EventBus.Register(EventBus.Event.VpnAdded, (profile: Profile) => {
      this.selectedProfile = profile.Id;
    });
    await this.refresh();
  }

  private async refresh() {
    this.logger.debug(`Refreshing data...`);

    this.setLoading();

    try {
      this.logger.debug(`Fetching network interfaces`);
      await this.profilesStore.fetchProfiles();
      this.logger.debug(`Network profiles fetched`, this.profilesStore.Profiles);

      if (this.selectedProfile === null && this.profilesStore.ProfilesVpn && this.profilesStore.ProfilesVpn.length > 0) {
        this.selectedProfile = this.profilesStore.ProfilesVpn[0].Id ?? null;
      }

    } catch (error) {
      Notify.Error(this.logger, `Could no get network profiles`, error);
    }

    this.setLoaded();
  }
}
